'use strict'

const IPFS = require('ipfs-core')

module.exports = IPFS
